import { BaseActions } from '../util/baseActions';

class BaseStringActions extends BaseActions {
  constructor() {
    super({ endpoint: 'base_strings', constantGroup: 'baseStrings' });
  }
}

export const baseStringActions = new BaseStringActions();



// WEBPACK FOOTER //
// ./src/actions/api/baseStrings.js